module.exports = __webpack_public_path__ + "img/forekspleksi.9bdb25e1.jpg";